export default "__VITE_ASSET__DcqV448b__"